import React, { useState } from "react";
import { Container, Row, Col, Button } from "react-bootstrap";
import ProjectCard from "./ProjectCards";
import Particle from "../Particle";

import cafeteria from "../../Assets/Projects/cafeteria.png"
import vmsmern from "../../Assets/Projects/vmsmern.png"
import sahbot from "../../Assets/Projects/sahbot.jpg"
import lora from "../../Assets/Projects/lora.jpg"
import virtualpainter from "../../Assets/Projects/virtualpainter.png"
import mutlichat from "../../Assets/Projects/mutlichat.png"
import interviewguru from "../../Assets/Projects/interviewguru.png"
import vmsphp from "../../Assets/Projects/vmsphp.png"
import wasteapi from "../../Assets/Projects/wasteapi.png"
import bookapi from "../../Assets/Projects/bookapi.png"
import bookamour from "../../Assets/Projects/bookamour.png"

import "./Projects.css";

function Projects() {
  const [showMore, setShowMore] = useState(false);

  return (
    <Container fluid className="project-section">
      <Particle />
      <Container>
        <h1 className="project-heading">
          My Recent <strong className="purple">Projects</strong>
        </h1>
        <p style={{ color: "white" }}>
          Here are some of the projects I have worked on.
        </p>

        {/* Main 3 Projects */}
        <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={cafeteria}
              isBlog={false}
              title={<span className="project-title">Digital Cafeteria - Canteen Management System</span>}
              description={
                <div className="project-description">
                  Built a responsive canteen portal with category-wise browsing, cart handling, and live order status updates. Developed an admin dashboard for menu management, tracking uncollected orders, and registering student/faculty accounts. Implemented backend CRUD APIs for menu updates, order placement, user registration, and review handling.
                  <span className="tech-stack">
                    Tech Stack: React.js, Node.js, Express.js, MongoDB, Bootstrap
                  </span>
                </div>
              }
              ghLink="https://github.com/AthmikaU/DigitalCafeteria"
              demoLink="https://digital-cafetaria.vercel.app/"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={vmsmern}
              isBlog={false}
              title={<span className="project-title">VMS - Voting Management System</span>}
              description={
                <div className="project-description">
                  Built a secure digital voting platform with real-time results and role-based dashboards (Admin, Voter, Party, Constituency). Implemented protected routes, session-based authentication, and dynamic UI rendering using the MERN stack. Created backend RESTful APIs for login, candidate registration, and ballot submission.
                  <span className="tech-stack">
                    Tech Stack: React.js, Node.js, Express.js, MongoDB, Bootstrap
                  </span>
                </div>
              }
              ghLink="https://github.com/AthmikaU/Voting-Management-System"
              demoLink="https://onlinevotingmanagementsystem.vercel.app/"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={sahbot}
              isBlog={false}
              title={<span className="project-title">SahBot - College Enquiry Chatbot</span>}
              description={
                <div className="project-description">
                  Developed a rule-based chatbot using Rasa to handle admission-related queries with intent classification and entity recognition. Integrated the bot into a simulated college website with support for light and dark themes. Customized NLU pipelines, stories, and domain files to improve conversational consistency.
                  <span className="tech-stack">
                    Tech Stack: Python, Rasa, HTML, CSS, JavaScript
                  </span>
                </div>
              }
              ghLink="https://github.com/AthmikaU/SahBot-Rasa"
            />
          </Col>
        </Row>

        {/* View More Button */}
        {!showMore && (
          <div className="text-center">
            <Button
              variant="outline-light"
              onClick={() => setShowMore(true)}
              style={{ marginTop: "20px", zIndex: 10, position: "relative" }}
            >
              View More Projects ↓
            </Button>
          </div>
        )}

        {/* Other Projects */}
        {showMore && (
          <Row style={{ justifyContent: "center", paddingTop: "30px" }}>
            <Col md={4} className="project-card">
              <ProjectCard
                imgPath={lora}
                isBlog={false}
                title={
                  <>
                    <span className="project-title">LoRa Distress Signalling System for Emergencies in Network-Dead Areas</span><br/>
                    <span className="project-title" style={{ color: "#ebb76aff" }}> (In Progress)</span>
                  </>
                }
                description={
                  <div className="project-description">
                    Developing an IoT-based emergency alert system using LoRa mesh network. ESP32 acts as a gateway, while a React + MQTT frontend displays real-time distress signals from multiple devices.
                    <span className="tech-stack">
                      Tech Stack: React.js, MQTT, ESP32, IoT
                    </span>
                  </div>
                }
              />
            </Col>

            <Col md={4} className="project-card">
              <ProjectCard
                imgPath={virtualpainter}
                isBlog={false}
                title={<span className="project-title">Virtual Painter Using Hand Tracking</span>}
                description={
                  <div className="project-description">
                    A Python-based virtual painting app using hand gestures tracked via MediaPipe as brush. Powered by OpenCV for real-time webcam drawing, supports colors, brush types, erase, and clear.
                    <span className="tech-stack">
                      Tech Stack: Python 3, OpenCV, MediaPipe, NumPy
                    </span>
                  </div>
                }
                ghLink="https://github.com/AthmikaU/VirtualPainter-OpenCV"
              />
            </Col>

            <Col md={4} className="project-card">
              <ProjectCard
                imgPath={mutlichat}
                isBlog={false}
                title={<span className="project-title">Multi-User Chat Application (Java)</span>}
                description={
                  <div className="project-description">
                    Java-based multi-user chat app supporting real-time communication with separate threads per client. Maintains synchronized chat history with timestamps.
                    <span className="tech-stack">
                      Tech Stack: Java, Multithreading, Socket Programming
                    </span>
                  </div>
                }
                ghLink="https://github.com/AthmikaU/Multi-User_Chat_Application"
              />
            </Col>

            <Col md={4} className="project-card">
              <ProjectCard
                imgPath={interviewguru}
                isBlog={false}
                title={<span className="project-title">InterviewMentor - AI Interview Prep</span>}
                description={
                  <div className="project-description">
                    AI platform analyzing resumes, generating interview questions, conducting mock interviews, and scoring confidence with feedback tracking.
                    <span className="tech-stack">
                      Tech Stack: React.js, Node.js, Express.js, Supabase, OpenAI, Whisper, MediaPipe
                    </span>
                  </div>
                }
                ghLink="https://github.com/AthmikaU/InterviewMentor-ConfidenceAndResumeTracker"
              />
            </Col>

            <Col md={4} className="project-card">
              <ProjectCard
                imgPath={vmsphp}
                isBlog={false}
                title={<span className="project-title">{/* Highlighted title */}VMS - Voting Management System (PHP, HTML, MySQL)</span>}
                description={
                  <>
                    Developed a digital voting platform with secure login, candidate registration, and result calculation using PHP, HTML, and MySQL. Implemented database-driven candidate and voter management.
                    <br /><br />
                    <span style={{ color: "#a855f7", fontWeight: "bold" }}>
                      Tech Stack: PHP, HTML, CSS, MySQL
                    </span>
                  </>
                }
                ghLink="https://github.com/AthmikaU/VMS-Voting_Management_System"
              />
            </Col>

            <Col md={4} className="project-card">
              <ProjectCard
                imgPath={wasteapi}
                isBlog={false}
                title={<span className="project-title">Waste Management & Complaint Handling</span>}
                description={
                  <div className="project-description">
                    Backend API to manage waste collection complaints with prioritization, resolution, undo functionality, and CSV logging.
                    <span className="tech-stack">
                      Tech Stack: Node.js, Express.js, REST API
                    </span>
                  </div>
                }
                ghLink="https://github.com/AthmikaU/WasteManagementAndComplaintHandling"
              />
            </Col>

            <Col md={4} className="project-card">
              <ProjectCard
                imgPath={bookapi}
                isBlog={false}
                title={<span className="project-title">Book Management API - Request Logging Middleware</span>}
                description={
                  <div className="project-description">
                    Node.js + Express backend API with middleware logging all HTTP requests for monitoring, debugging, and audit tracking. Fully tested CRUD operations via Postman.
                    <span className="tech-stack">
                      Tech Stack: Node.js, Express.js, Middleware, REST API
                    </span>
                  </div>
                }
                ghLink="https://github.com/AthmikaU/AthmikaU_Sahyadri_React_Task5"
                // demoLink="https://athmikau-sahyadri-react-task5.onrender.com"
              />
            </Col>

            <Col md={4} className="project-card">
              <ProjectCard
                imgPath={bookamour}
                isBlog={false}
                title={<span className="project-title">Book-Amour - Online Book Store UI</span>}
                description={
                  <div className="project-description">
                    A modern and interactive frontend UI for an online bookstore using Bootstrap. Includes carousels, book cards, search, filters, modals, and responsive design.
                    <span className="tech-stack">
                      Tech Stack: HTML, CSS, Bootstrap
                    </span>
                  </div>
                }
                ghLink="https://github.com/AthmikaU/Book-Amour"
              />
            </Col>
          </Row>
        )}
      </Container>
    </Container>
  );
}

export default Projects;
